import {
  EMAIL_UPDATE_ERROR,
  EMAIL_UPDATE_SUCCESS_IN,
  EMAIL_UPDATE_FAILED_IN
} from '../constants/response-messages';

/**
 * Email update response messages handler
 * @param {object} data - Email update response
 * @param {object} error - Email update error
 * @param {number} status - Email update status code
 */
export const getEmailUpdateResponseMessages = (data, error, status) => {
  if (error) {
    return {
      emailUpdateFailedMessage: `${EMAIL_UPDATE_ERROR} status code: ${status}`
    };
  }

  const successIn = [];
  const failedIn = [];
  if (data && data === "Email Updated Successfully") {
    return {
      emailUpdateSuccessMessage: data,
      emailUpdateFailedMessage: null,
    };
  } else if (data && data.count() > 0) {
    const systemsUpdateOutcome = {
      icoms: data.get('icomsSuccess'),
      firebase: data.get('firebaseSuccess'),
      symphonica: data.get('symphonicSuccess') || data.get('symphonicaSuccess')
    };

    for (const key in systemsUpdateOutcome) {
      if (systemsUpdateOutcome.hasOwnProperty(key)) {
        if (systemsUpdateOutcome[key] === true) {
          successIn.push(key);
        }

        if (systemsUpdateOutcome[key] === false) {
          failedIn.push(key);
        }
      }
    }
  }

  return {
    emailUpdateSuccessMessage: successIn.length > 0
      ? `${EMAIL_UPDATE_SUCCESS_IN} ${successIn.join(", ").toUpperCase()}`
      : null,
    emailUpdateFailedMessage: failedIn.length > 0
      ? `${EMAIL_UPDATE_FAILED_IN} ${failedIn.join(", ").toUpperCase()}`
      : null,
  };
};



// WEBPACK FOOTER //
// ./src/utils/emailUpdateUtils.js